var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRulerPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a8cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#60acef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c0ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(80 80) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    transform: "translate(20.975 21.211)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.43,
    height: 38.43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.43,
    height: 37.43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_pencil-ruler",
    "data-name": "Path / pencil-ruler",
    d: "M4.087,27.955v6.281h6.281L28.893,15.694,22.612,9.413,4.087,27.955m32.846,1.859-7.119,7.119-8.71-8.71,2.965-2.965,1.675,1.675,4.137-4.154,2.378,2.378-2.445,2.378,1.775,1.675,2.378-2.345,2.965,2.948M10.133,17.2,1.39,8.509,8.509,1.39l2.948,2.965L7.319,8.509l1.792,1.775,4.12-4.154L15.61,8.509,13.232,10.87l1.675,1.675L10.133,17.2M33.75,10.787a1.668,1.668,0,0,0,0-2.362L29.831,4.572a1.668,1.668,0,0,0-2.362,0L24.387,7.638l6.281,6.281Z",
    transform: "translate(20.604 20.854)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerPencil);
export default __webpack_public_path__ + "static/media/ruler-pencil.905fff5eb53af5519a7ae030b0e9b8a5.svg";
export { ForwardRef as ReactComponent };